
  var _styles = {
  "topArea-normal": {
    "width": "4.56rem",
    "height": "3.41333rem"
  },
  "cardContainer-normal": {
    "width": "4.56rem",
    "height": "6.92rem",
    "background": "#fff",
    "borderRadius": "0.32rem",
    "overflow": "hidden"
  },
  "topArea-small": {
    "width": "4.18667rem",
    "height": "3.13333rem"
  },
  "cardContainer-small": {
    "width": "4.18667rem",
    "height": "6.53333rem",
    "background": "#fff",
    "borderRadius": "0.32rem",
    "overflow": "hidden"
  },
  "bookInfoContainer": {
    "position": "absolute",
    "bottom": "0.10667rem",
    "left": "0.10667rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "borderRadius": "0.16rem",
    "paddingTop": "0.05333rem",
    "paddingRight": "0.10667rem",
    "paddingBottom": "0.05333rem",
    "paddingLeft": "0.10667rem"
  },
  "locationIcon": {
    "fontSize": "0.26667rem",
    "color": "rgb(255,255,255)"
  },
  "bookInfo": {
    "fontWeight": "500",
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "0.26667rem",
    "color": "rgb(255,255,255)",
    "marginLeft": "0.08rem"
  },
  "headIcon": {
    "position": "absolute",
    "top": "0.21333rem",
    "right": "0.21333rem",
    "borderRadius": "0.10667rem",
    "overflow": "hidden"
  },
  "headIconImg": {
    "width": "1.09333rem",
    "height": "0.42667rem",
    "borderRadius": "0.05333rem"
  },
  "headIconImageContainer": {
    "position": "absolute",
    "top": 0,
    "left": 0,
    "width": "2rem",
    "height": "0.16rem",
    "borderTopLeftRadius": "0.32rem",
    "borderBottomRightRadius": "0.32rem"
  },
  "headIconImage": {
    "borderTopLeftRadius": "0.32rem",
    "borderBottomRightRadius": "0.32rem"
  },
  "headIconText": {
    "fontSize": "0.32rem"
  },
  "poiName": {
    "fontWeight": "600",
    "fontFamily": "PingFangSC-Semibold",
    "fontSize": "0.42667rem",
    "color": "rgb(34,34,34)",
    "letterSpacing": 0,
    "lineHeight": "0.58667rem",
    "marginBottom": "0.10667rem"
  },
  "scoreRatingUserReviewContainer": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center"
  },
  "score": {
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.26667rem",
    "color": "rgb(6,68,155)",
    "marginRight": "0.02667rem"
  },
  "rating": {
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.26667rem",
    "color": "rgb(0,64,153)",
    "marginRight": "0.02667rem"
  },
  "userReview": {
    "fontWeight": "400",
    "color": "rgb(0,64,153)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.29333rem",
    "lineHeight": "0.34667rem",
    "height": "0.34667rem",
    "marginBottom": "0.16rem"
  },
  "discountContent": {
    "fontWeight": "500",
    "fontSize": "0.26667rem",
    "color": "rgb(255,75,16)",
    "letterSpacing": 0,
    "textAlign": "left"
  },
  "salesCountContent": {
    "fontWeight": "400",
    "fontSize": "0.26667rem",
    "color": "rgb(255,75,16)",
    "letterSpacing": 0
  },
  "salesCountContainer": {
    "borderRadius": "0.08rem",
    "paddingTop": 0,
    "paddingRight": "0.08rem",
    "paddingBottom": 0,
    "paddingLeft": "0.08rem",
    "marginRight": "0.10667rem",
    "borderWidth": "0.02667rem",
    "borderStyle": "solid",
    "borderColor": "rgb(255,226,188)",
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center",
    "height": "0.37333rem"
  },
  "discountContainer": {
    "borderWidth": "0.02667rem",
    "borderStyle": "solid",
    "borderColor": "rgb(255,226,188)",
    "borderRadius": "0.10667rem",
    "paddingTop": 0,
    "paddingRight": "0.08rem",
    "paddingBottom": 0,
    "paddingLeft": "0.08rem",
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center",
    "height": "0.37333rem",
    "marginRight": "0.10667rem"
  },
  "smallTagContainer": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "flex-start",
    "marginBottom": "0.10667rem"
  },
  "prev": {
    "fontWeight": "500",
    "fontFamily": "PingFang SC",
    "fontSize": "0.29333rem",
    "color": "rgb(255,75,16)",
    "letterSpacing": 0,
    "lineHeight": "0.37333rem"
  },
  "price": {
    "color": "rgb(255,75,16)",
    "fontFamily": "PingFang SC",
    "fontWeight": "700",
    "fontSize": "0.56rem",
    "height": "0.66667rem",
    "letterSpacing": 0
  },
  "behind": {
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.29333rem",
    "color": "rgb(255,75,16)",
    "letterSpacing": 0
  },
  "buyButtonText": {
    "fontWeight": "600",
    "fontFamily": "PingFangSC-Semibold",
    "fontSize": "0.37333rem",
    "color": "rgb(255,255,255)",
    "letterSpacing": 0,
    "lineHeight": "0.53333rem"
  },
  "sellPrice": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "flex-end"
  },
  "originPrice": {
    "textDecoration": "line-through",
    "WebkitTextDecorationColor": "#999",
    "textDecorationColor": "#999",
    "fontWeight": "400",
    "fontSize": "0.29333rem",
    "color": "rgb(153,153,153)",
    "letterSpacing": 0,
    "lineHeight": "0.34667rem"
  },
  "priceArea": {
    "position": "relative"
  },
  "priceWrap": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "flex-end"
  },
  "buyButtonWrap": {
    "position": "absolute",
    "right": 0,
    "bottom": 0,
    "backgroundColor": "rgb(255,75,16)",
    "borderRadius": "0.53333rem",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center",
    "paddingTop": "0.13333rem",
    "paddingRight": "0.32rem",
    "paddingBottom": "0.13333rem",
    "paddingLeft": "0.32rem"
  },
  "bottomArea": {
    "width": "100%",
    "height": "3.50667rem",
    "padding": "0.16rem",
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "space-between"
  },
  "positionInfo": {
    "fontSize": "0.24rem",
    "fontFamily": "PingFangSC-Regular",
    "color": "rgb(119,119,119)",
    "textDecoration": "none",
    "marginBottom": "0.02667rem"
  },
  "headTag": {
    "position": "absolute",
    "top": 0,
    "left": 0,
    "paddingTop": "0.04rem",
    "paddingRight": "0.16rem",
    "paddingBottom": "0.04rem",
    "paddingLeft": "0.16rem",
    "borderTopLeftRadius": "0.32rem",
    "borderBottomRightRadius": "0.32rem"
  },
  "headTagImg": {
    "width": "1.38667rem",
    "height": "0.42667rem",
    "position": "absolute",
    "top": 0,
    "left": 0
  },
  "headTagText": {
    "fontSize": "0.26667rem",
    "fontFamily": "PingFang SC"
  }
};

  if (typeof FontFace === 'function') {
    
    var fontFace0 = new FontFace('MTfin-bold2', 'url("https://s0.meituan.net/bs/tempfs/file/dongxiaoxue/MTfin-bold2.0.ttf") format("truetype")');
    document.fonts.add(fontFace0);
    
  }
    


  module.exports = _styles;
  